const TOUR_INVOICE_CONTENT = [
  {
    content: (
      <div>
        <h2>Welcome</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Search & Filter',
    content: 'Use criteria based filter and search to view invoice number',
    placement: 'top',
    target: '.ebz-filters-btn'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];

const TOUR_INVOICE_CONTENT1 = [];

export { TOUR_INVOICE_CONTENT, TOUR_INVOICE_CONTENT1 };
